import { useRef } from 'react';

/** KU
 *
 * A hook that updates the value of a ref on each render
 *
 * based on https://github.com/wellyshen/react-cool-virtual/blob/master/src/utils/useLatest.ts
 *
 * @param value latest value for the ref
 * @returns `ref` containing the value
 */
export default function useLatest<T>(value: T) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}
